import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../hooks/hooks";
import { RootState } from "../redux/store";
import { readSafeRedirect } from "../utils/returnPath";

interface Props {
    children: React.ReactNode;
    /** Where to send an authenticated user when no safe `?redirect=` is present. */
    fallback?: string;
}

/**
 * Wraps the sign-in pages (/login, /owner-login, /register, /owner-register).
 * While signed out it renders the page. The moment the session is
 * established it forwards to the page the user came from, carried in
 * `?redirect=` by `buildLoginPath`, or to `fallback` (open redirects and
 * sign-in pages are rejected by `readSafeRedirect`).
 */
const AuthEntryRoute: React.FC<Props> = ({ children, fallback = "/" }) => {
    const location = useLocation();
    const isAuthenticated = useAppSelector(
        (state: RootState) => state.auth.isAuthenticated
    );
    const token = useAppSelector((state: RootState) => state.auth.access_token);

    if (isAuthenticated && token) {
        return (
            <Navigate
                to={readSafeRedirect(location.search ?? "", fallback)}
                replace={true}
            />
        );
    }
    return <>{children}</>;
};

export default AuthEntryRoute;
